import { useTranslation } from 'react-i18next';
import generateNumberArray from '../utils/generateNumberArray';

const useRespondentVolumeOptions = () => {
  const { t } = useTranslation('scout');

  const volumesArr = generateNumberArray(100, 1000, 100);
  const formattedRespondentVolumes = volumesArr.map((volume) => ({ label: volume, value: volume }));

  return [...formattedRespondentVolumes, { label: t('other'), value: 'Other' }];
};

export default useRespondentVolumeOptions;
